export default "__VITE_ASSET__CXDNd0hS__"